import { render, staticRenderFns } from "./AppDashboardChart.vue?vue&type=template&id=c5c65dc2"
import script from "./AppDashboardChart.vue?vue&type=script&lang=js"
export * from "./AppDashboardChart.vue?vue&type=script&lang=js"
import style0 from "./AppDashboardChart.vue?vue&type=style&index=0&id=c5c65dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports